import {
  section,
  container,
  cardTitle,
  coloredShadow,
  mlAuto,
  mrAuto,
  grayColor,
  secondaryColor,
} from "assets/jss/material-kit-pro-react.js";

import customCheckboxRadioSwitch from "assets/jss/material-kit-pro-react/customCheckboxRadioSwitchStyle.js";

import tooltipsStyle from "assets/jss/material-kit-pro-react/tooltipsStyle.js";

const styles = {
  ...customCheckboxRadioSwitch,
  ...tooltipsStyle,
  checkRoot: {
    padding: "14px",
    "&:hover": {
      backgroundColor: "unset !important",
    },
  },
  coloredShadow,
  mlAuto,
  mrAuto,
  cardTitle: {
    ...cardTitle,
    textAlign: "rigth",
    marginBottom: "0px !important",
  },
  cardDescription: {
    color: grayColor[0],
    textAlign: "center",
  },
  container: {
    ...container,
  },
  description: {
    color: grayColor[0],
  },
  section: {
    ...section,
    padding: "20px 0px",
  },
  priceContainer: {
    display: "inline-flex",
  },
  price: {
    fontSize: "20px",
    fontWeight: "500",
    color: secondaryColor,
  },
  oldPrice: {
    textDecorationLine: "line-through",
    fontWeight: "500",
    fontSize: "12px",
    //color: dangerColor[0],
  },
  pullRight: {
    float: "right",
  },
  cardHeaderImage: {
    position: "relative",
    padding: "0",
    zIndex: "1",
    marginLeft: "15px",
    marginRight: "15px",
    marginTop: "-30px",
    borderRadius: "6px",
    "& img": {
      width: "100%",
      borderRadius: "6px",
      pointerEvents: "none",
    },
    "& a": {
      display: "block",
    },
  },
  justifyContentBetween: {
    WebkitBoxPack: "justify!important",
    justifyContent: "space-between !important",
  },
  customExpandPanel: {
    maxHeight: "350px",
    overflowY: "scroll",
    "&  label": {
      display: "flex",
    },
  },
  priceSlider: {
    fontWeight: "500",
  },
  refineButton: {
    margin: "-3px 0",
  },
  cardBodyRefine: {
    paddingLeft: "0px",
    paddingRight: "5px",
  },
  textLeft: {
    textAlign: "left",
  },
};

export default styles;
